import { PodPtsPage } from 'pageModules/PodPtsPage';

export default PodPtsPage;
